export const removeKeyFromObjectState = (setter, key) => {
  setter((prevState) => {
    const newState = { ...prevState };
    delete newState[key]; // Remove the specific key
    return newState;
  });
};

export const updateObjectState = (setter, key, value) => {
  setter((prevState) => {
    return {
      ...prevState,
      [key]: value, // Update the state dynamically
    };
  });
};

export const removeKeysFromObjectState = (setter, arrayObj, index) => {
  setter((prevState) => {
    const newObj = { ...prevState };

    for (let i = index; i < arrayObj.length; i++) {
      const nextObjKey = arrayObj[i].id;
      delete newObj[nextObjKey]; // Remove the key from the object
    }

    return newObj;
  });
};

export const updateAndRemoveKeysFromObjectState = (
  setter,
  arrayObj,
  key,
  value,
  index
) => {
  setter((prevState) => {
    // Create a new object with or without updating the current value
    const newObj = { ...prevState, [key]: value };

    // Reset answers for subsequent arrayObj
    for (let i = index; i < arrayObj.length; i++) {
      const nextObjKey = arrayObj[i].id;
      delete newObj[nextObjKey];
    }

    return newObj;
  });
};
